import {
  ICart,
  ICustomer,
  IDataLayer,
  IOrder,
  IProduct,
  IVariant,
} from '../../../types';

import toDataLayerCart from './objects/cart';
import toDataLayerOrder from './objects/order';
import toDataLayerProduct from './objects/product';
import toDataLayerEnv from './objects/env';
import toDataLayerSite from './objects/site';
import toDataLayerPage from './objects/page';
import toDataLayerCustomer from './objects/customer';

export type IETL = {
  cart: (cart: ICart) => IDataLayer;
  customer: (customer: ICustomer) => IDataLayer;
  env: (env: string) => IDataLayer;
  order: (order: IOrder) => IDataLayer;
  page: () => IDataLayer;
  product: (
    product: IProduct,
    variant?: IVariant,
    prefix?: string,
  ) => IDataLayer;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  site: (site: Record<string, any>) => IDataLayer;
};

const ETL: IETL = {
  cart: toDataLayerCart,
  customer: toDataLayerCustomer,
  env: toDataLayerEnv,
  order: toDataLayerOrder,
  page: toDataLayerPage,
  product: toDataLayerProduct,
  site: toDataLayerSite,
};

export default ETL;
